import { useRef, useEffect, useCallback, useState, } from 'react'
import { web3 } from '../helpers/config';

export const useInitialBlock = () => {
    const [currentBlock, setCurrentBlock] = useState(0)
    const timer: any = useRef(null)
    let checkOnStart: boolean = false;

    const setBlockNumber = useCallback(async () => {
        const blockNumber = await web3.eth.getBlockNumber();
        setCurrentBlock(blockNumber);
    }, []);

    useEffect(() => {
        if (!checkOnStart) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            checkOnStart = true;
            setBlockNumber();
        }
        timer.current = setInterval(async () => {
            setBlockNumber();
        }, 5000)
        return () => clearInterval(timer.current)
    }, [checkOnStart, setBlockNumber, timer])

    return currentBlock;
}